import { computed } from "vue";
import type { IUserPermission } from "@/core/entity/IUserPermission";


export default {
  mounted(el, binding, vnode) {
    const func = binding.value.function;
    console.log(func)
    const vm = binding.instance
    const permissions = computed<any[]>(() => vm.$store?.state.PermissionModule.permissions)
    if (permissions.value === undefined || permissions.value === null) {
      el.classList.add("d-none")
    }
    vm.$store.watch(() => vm.$store.state.PermissionModule.permissions, (pers: any[]) => {
      const hasAccess = pers.includes(func)
      if (!hasAccess) {
        if (el.parentNode) {
          el.parentNode.removeChild(el);
        }
      } else {
        el.classList.remove("d-none")
      }
    })
    if (permissions.value.length > 0) {
      const hasAccess = permissions.value.includes(func)
      if (!hasAccess) {
        el.parentNode.removeChild(el);
      }
    }
  }

}